export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8063.adb5e967.jpg";